import React from "react";
import { Route } from "react-router";
import DashboardRoutes from "./dashboardRoutes";
import ApplicationRoutes from "./applicationRoutes";
import SettingsRoutes from "./settingsRoutes";
import EmployeeRoutes from "./employeeRoutes";
import DemoStoreRoutes from "./demoStoreRoutes";
import ThemeRoutes from "./themeRoutes";
import CouponRoutes from "./couponRoutes";
import PaymentMethodRoutes from "./paymentMethodRoutes";
import WebhookRoutes from "./webhookRoutes";
import NotificationRoutes from "./notificationRoutes";
import SubscriptionRoutes from "./subscriptionRoutes";
import NotFound from "pages/not-found";
import AuthRoute from "helpers/authentication/authRoute";
import PaymentRoutes from "./paymentRoutes";

const AppRoutes = () => (
    <>
        {DashboardRoutes()}
        {ApplicationRoutes()}
        {SettingsRoutes()}
        {EmployeeRoutes()}
        {DemoStoreRoutes()}
        {ThemeRoutes()}
        {CouponRoutes()}
        {PaymentMethodRoutes()}
        {WebhookRoutes()}
        {NotificationRoutes()}
        {SubscriptionRoutes()}
        {PaymentRoutes()}

        <Route
            path="*"
            element={
                <AuthRoute>
                    <NotFound />
                </AuthRoute>
            }
        />
    </>
);

export default AppRoutes;
